// Mock data for Sky Trips website

export const domesticTours = [
  {
    id: '1',
    title: 'Golden Triangle Tour',
    destination: 'Delhi - Agra - Jaipur',
    duration: '5 Days / 4 Nights',
    price: '₹15,999',
    image: 'https://images.unsplash.com/photo-1564507592333-c60657eea523',
    description: 'Explore the iconic Golden Triangle covering Delhi, Agra (Taj Mahal), and Jaipur palaces',
    highlights: ['Taj Mahal Visit', 'Amber Fort', 'India Gate', 'Qutub Minar'],
    category: 'domestic',
    gallery: [
      'https://images.unsplash.com/photo-1688781298681-ae1f2d470b31',
      'https://images.unsplash.com/photo-1678966432189-d58296e45ad2',
      'https://images.unsplash.com/photo-1705927122615-02dcef3b1465',
      'https://images.unsplash.com/photo-1631781101051-121237b6c7cb',
      'https://images.unsplash.com/photo-1682602336608-326d2a985fbe',
      'https://images.pexels.com/photos/12412157/pexels-photo-12412157.jpeg',
      'https://images.unsplash.com/photo-1534758607507-754e582adfa4',
      'https://images.unsplash.com/photo-1682321136734-8cc95d0912be',
      'https://images.unsplash.com/photo-1682583554426-b10847a7c7fa',
      'https://images.unsplash.com/photo-1695395550316-8995ae9d35ff'
    ],
    inclusions: ['4 nights accommodation in 4-star hotels', 'Daily breakfast and dinner', 'Private AC vehicle for all transfers', 'English speaking tour guide', 'All monument entry fees', 'Airport pickup and drop'],
    exclusions: ['Airfare/Train tickets', 'Lunch', 'Personal expenses', 'Tips and gratuities', 'Travel insurance'],
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Delhi - City Tour',
        description: 'Arrive in Delhi and check into your hotel. After refreshments, start your Delhi sightseeing tour covering India Gate, Rashtrapati Bhavan, Qutub Minar, and Lotus Temple. Evening free for leisure.',
        meals: 'Dinner',
        accommodation: 'Hotel in Delhi'
      },
      {
        day: 2,
        title: 'Delhi to Agra - Taj Mahal Visit',
        description: 'After breakfast, drive to Agra (4 hours). Visit the magnificent Taj Mahal at sunset, one of the Seven Wonders of the World. Later visit Agra Fort, a UNESCO World Heritage site.',
        meals: 'Breakfast, Dinner',
        accommodation: 'Hotel in Agra'
      },
      {
        day: 3,
        title: 'Agra to Jaipur via Fatehpur Sikri',
        description: 'Morning drive to Jaipur with a stop at Fatehpur Sikri, the abandoned Mughal city. Continue to Jaipur, the Pink City. Evening free to explore local markets.',
        meals: 'Breakfast, Dinner',
        accommodation: 'Hotel in Jaipur'
      },
      {
        day: 4,
        title: 'Jaipur City Tour',
        description: 'Visit the majestic Amber Fort with elephant ride option. Explore City Palace, Jantar Mantar observatory, and Hawa Mahal. Evening visit to Jal Mahal for photos.',
        meals: 'Breakfast, Dinner',
        accommodation: 'Hotel in Jaipur'
      },
      {
        day: 5,
        title: 'Jaipur to Delhi Departure',
        description: 'After breakfast, drive back to Delhi (5 hours). Transfer to airport/railway station for your onward journey with wonderful memories.',
        meals: 'Breakfast',
        accommodation: 'N/A'
      }
    ]
  },
  {
    id: '2',
    title: 'Kerala Package',
    destination: 'Cochin - Munnar - Alleppey',
    duration: '6 Days / 5 Nights',
    price: '₹22,999',
    image: 'https://customer-assets.emergentagent.com/job_explore-skytrips/artifacts/enbsx79k_Kerala%20Package.jpg',
    description: 'Experience God\'s Own Country with houseboats, tea gardens, and serene backwaters',
    highlights: ['Houseboat Stay', 'Tea Plantation Tour', 'Kathakali Dance', 'Beach Visit'],
    category: 'domestic',
    gallery: [
      'https://images.unsplash.com/photo-1593693397690-362cb9666fc2',
      'https://images.unsplash.com/photo-1593693411515-c20261bcad6e',
      'https://images.unsplash.com/photo-1704365159747-1f7b8913044f',
      'https://images.unsplash.com/photo-1624554305378-0f440dd3a8c1',
      'https://images.unsplash.com/photo-1666891717987-7509e81db05a',
      'https://images.unsplash.com/photo-1650884986392-984358536050',
      'https://images.unsplash.com/photo-1730351111586-1c98c8049f6f',
      'https://images.pexels.com/photos/392100/pexels-photo-392100.jpeg',
      'https://images.unsplash.com/photo-1558025638-565ae7710b3f',
      'https://images.pexels.com/photos/33526447/pexels-photo-33526447.jpeg'
    ],
    inclusions: ['5 nights accommodation', '1 night houseboat stay', 'Daily breakfast', 'Private vehicle for transfers', 'Sightseeing as per itinerary', 'Kathakali show tickets'],
    exclusions: ['Airfare', 'Lunch and dinner (except houseboat)', 'Personal expenses', 'Optional activities'],
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Cochin',
        description: 'Arrive in Cochin and transfer to hotel. Visit Fort Kochi, Chinese Fishing Nets, St. Francis Church, and Dutch Palace. Evening Kathakali dance performance.',
        meals: 'Breakfast',
        accommodation: 'Hotel in Cochin'
      },
      {
        day: 2,
        title: 'Cochin to Munnar',
        description: 'Drive to Munnar (4 hours) through scenic landscapes. Visit Cheeyappara and Valara waterfalls en route. Check into hotel and relax.',
        meals: 'Breakfast',
        accommodation: 'Hotel in Munnar'
      },
      {
        day: 3,
        title: 'Munnar Sightseeing',
        description: 'Full day Munnar tour covering Tea Museum, Mattupetty Dam, Echo Point, Kundala Lake, and Eravikulam National Park. Evening at leisure.',
        meals: 'Breakfast',
        accommodation: 'Hotel in Munnar'
      },
      {
        day: 4,
        title: 'Munnar to Alleppey - Houseboat Check-in',
        description: 'Morning drive to Alleppey (4.5 hours). Check into your private houseboat at noon. Cruise through the backwaters, enjoy Kerala cuisine onboard.',
        meals: 'Breakfast, Lunch, Dinner',
        accommodation: 'Houseboat in Alleppey'
      },
      {
        day: 5,
        title: 'Alleppey to Cochin',
        description: 'Disembark from houseboat after breakfast. Drive back to Cochin. Visit Marine Drive, Lulu Mall for shopping. Overnight in Cochin.',
        meals: 'Breakfast',
        accommodation: 'Hotel in Cochin'
      },
      {
        day: 6,
        title: 'Departure from Cochin',
        description: 'After breakfast, transfer to airport for your departure flight with beautiful memories of Kerala.',
        meals: 'Breakfast',
        accommodation: 'N/A'
      }
    ]
  },
  {
    id: '3',
    title: 'Goa Beach Paradise',
    destination: 'North & South Goa',
    duration: '4 Days / 3 Nights',
    price: '₹12,999',
    image: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e',
    description: 'Relax on pristine beaches, enjoy water sports, and explore Portuguese heritage',
    highlights: ['Beach Hopping', 'Water Sports', 'Night Markets', 'Fort Aguada'],
    category: 'domestic',
    gallery: [
      'https://images.unsplash.com/photo-1512343879784-a960bf40e7f2',
      'https://images.unsplash.com/photo-1552733407-5d5c46c3bb3b',
      'https://images.unsplash.com/photo-1587922546307-776227941871',
      'https://images.unsplash.com/photo-1544413660-299165566b1d',
      'https://images.unsplash.com/photo-1588466585717-f8041aec7875',
      'https://images.unsplash.com/photo-1589227365533-cee630dfa8a7',
      'https://images.unsplash.com/photo-1596423562506-dca0c96d2c66',
      'https://images.unsplash.com/photo-1551244072-5d12893278ab',
      'https://images.unsplash.com/photo-1584735175315-9d5df23860e6',
      'https://images.unsplash.com/photo-1570655568562-99f26e0b55e0'
    ],
    inclusions: ['3 nights hotel accommodation', 'Daily breakfast', 'Airport transfers', 'North and South Goa sightseeing'],
    exclusions: ['Airfare', 'Lunch and dinner', 'Water sports charges', 'Entry fees'],
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Goa',
        description: 'Arrive at Goa airport and transfer to hotel. Relax on the beach. Evening free to explore nearby markets and restaurants.',
        meals: 'N/A',
        accommodation: 'Hotel in Goa'
      },
      {
        day: 2,
        title: 'North Goa Tour',
        description: 'Visit Fort Aguada, Calangute Beach, Baga Beach, Anjuna Beach, and Vagator Beach. Evening visit to Chapora Fort for sunset views.',
        meals: 'Breakfast',
        accommodation: 'Hotel in Goa'
      },
      {
        day: 3,
        title: 'South Goa Tour',
        description: 'Explore Old Goa Churches (UNESCO site), Mangueshi Temple, Shanta Durga Temple, Palolem Beach, and Colva Beach.',
        meals: 'Breakfast',
        accommodation: 'Hotel in Goa'
      },
      {
        day: 4,
        title: 'Departure',
        description: 'Free time for shopping or beach activities. Transfer to airport for departure.',
        meals: 'Breakfast',
        accommodation: 'N/A'
      }
    ]
  },
  {
    id: '4',
    title: 'Himachal Adventure',
    destination: 'Shimla - Manali - Dharamshala',
    duration: '7 Days / 6 Nights',
    price: '₹18,999',
    image: 'https://customer-assets.emergentagent.com/job_explore-skytrips/artifacts/dq5vekqz_Himachal%20Adventure.jpg',
    description: 'Discover the beauty of Himalayas with snow-capped mountains and valleys',
    highlights: ['Rohtang Pass', 'Solang Valley', 'Mall Road', 'Hadimba Temple'],
    category: 'domestic',
    inclusions: ['6 nights accommodation', 'Daily breakfast and dinner', 'All transfers', 'Sightseeing by private vehicle'],
    exclusions: ['Airfare', 'Lunch', 'Rohtang Pass permit', 'Adventure activities'],
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Shimla',
        description: 'Arrive in Shimla, check into hotel. Evening walk on Mall Road and Ridge. Visit Christ Church and Scandal Point.',
        meals: 'Dinner',
        accommodation: 'Hotel in Shimla'
      },
      {
        day: 2,
        title: 'Shimla Local Sightseeing',
        description: 'Visit Kufri, Jakhoo Temple, Indian Institute of Advanced Study. Evening free for shopping.',
        meals: 'Breakfast, Dinner',
        accommodation: 'Hotel in Shimla'
      },
      {
        day: 3,
        title: 'Shimla to Manali',
        description: 'Drive to Manali (7-8 hours) through scenic Kullu Valley. Check into hotel and relax.',
        meals: 'Breakfast, Dinner',
        accommodation: 'Hotel in Manali'
      },
      {
        day: 4,
        title: 'Manali Local Sightseeing',
        description: 'Visit Hadimba Temple, Manu Temple, Vashisht Hot Springs, Tibetan Monastery, and Old Manali village.',
        meals: 'Breakfast, Dinner',
        accommodation: 'Hotel in Manali'
      },
      {
        day: 5,
        title: 'Solang Valley and Rohtang Pass',
        description: 'Full day excursion to Solang Valley and Rohtang Pass (subject to permit). Enjoy snow activities and stunning views.',
        meals: 'Breakfast, Dinner',
        accommodation: 'Hotel in Manali'
      },
      {
        day: 6,
        title: 'Manali to Dharamshala',
        description: 'Drive to Dharamshala (7 hours). Visit Dalai Lama Temple, Bhagsu Waterfall, and McLeod Ganj market.',
        meals: 'Breakfast, Dinner',
        accommodation: 'Hotel in Dharamshala'
      },
      {
        day: 7,
        title: 'Departure',
        description: 'After breakfast, transfer to airport/railway station for departure.',
        meals: 'Breakfast',
        accommodation: 'N/A'
      }
    ]
  },
  {
    id: '5',
    title: 'Rajasthan Royal Heritage',
    destination: 'Jaipur - Udaipur - Jodhpur',
    duration: '6 Days / 5 Nights',
    price: '₹19,999',
    image: 'https://customer-assets.emergentagent.com/job_explore-skytrips/artifacts/bvgd05jj_Rajasthan%20Royal%20Heritage.jpg',
    description: 'Experience royal Rajasthan with majestic forts, palaces, and desert safari',
    highlights: ['City Palace', 'Lake Pichola', 'Mehrangarh Fort', 'Camel Safari'],
    category: 'domestic',
    inclusions: ['5 nights accommodation in heritage hotels', 'Daily breakfast and dinner', 'All transfers', 'Camel safari in desert'],
    exclusions: ['Airfare', 'Lunch', 'Monument entry fees', 'Optional activities'],
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Jaipur',
        description: 'Arrive in Jaipur and check into hotel. Visit City Palace, Jantar Mantar, and Hawa Mahal. Evening at Chokhi Dhani village resort.',
        meals: 'Dinner',
        accommodation: 'Hotel in Jaipur'
      },
      {
        day: 2,
        title: 'Jaipur Sightseeing',
        description: 'Morning visit to Amber Fort with elephant ride. Explore Nahargarh Fort and Jal Mahal. Shopping at Johari Bazaar.',
        meals: 'Breakfast, Dinner',
        accommodation: 'Hotel in Jaipur'
      },
      {
        day: 3,
        title: 'Jaipur to Udaipur',
        description: 'Drive to Udaipur (6-7 hours). En route visit Chittorgarh Fort. Check into hotel and evening boat ride on Lake Pichola.',
        meals: 'Breakfast, Dinner',
        accommodation: 'Hotel in Udaipur'
      },
      {
        day: 4,
        title: 'Udaipur City Tour',
        description: 'Visit City Palace, Jagdish Temple, Saheliyon ki Bari, and Fateh Sagar Lake. Evening at Bagore ki Haveli for cultural show.',
        meals: 'Breakfast, Dinner',
        accommodation: 'Hotel in Udaipur'
      },
      {
        day: 5,
        title: 'Udaipur to Jodhpur',
        description: 'Drive to Jodhpur (5 hours). Visit Mehrangarh Fort, Jaswant Thada, and Umaid Bhawan Palace. Evening desert camel safari.',
        meals: 'Breakfast, Dinner',
        accommodation: 'Hotel in Jodhpur'
      },
      {
        day: 6,
        title: 'Departure',
        description: 'Morning visit to Mandore Gardens. Transfer to airport for departure.',
        meals: 'Breakfast',
        accommodation: 'N/A'
      }
    ]
  },
  {
    id: '6',
    title: 'Ladakh Expedition',
    destination: 'Leh - Nubra Valley - Pangong Lake',
    duration: '8 Days / 7 Nights',
    price: '₹32,999',
    image: 'https://customer-assets.emergentagent.com/job_explore-skytrips/artifacts/djsr4t49_Ladakh%20Expedition.jpg',
    description: 'Adventure through the highest motorable passes and stunning landscapes',
    highlights: ['Pangong Lake', 'Nubra Valley', 'Khardung La', 'Magnetic Hill'],
    category: 'domestic',
    inclusions: ['7 nights accommodation', 'Daily breakfast and dinner', 'All transfers and permits', 'Oxygen cylinders in vehicle'],
    exclusions: ['Airfare to Leh', 'Lunch', 'Inner line permits', 'Adventure activities'],
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Leh',
        description: 'Arrive in Leh and rest for acclimatization. Light activities only. Visit Leh Market and Shanti Stupa in evening.',
        meals: 'Dinner',
        accommodation: 'Hotel in Leh'
      },
      {
        day: 2,
        title: 'Leh Local Sightseeing',
        description: 'Visit Leh Palace, Hall of Fame Museum, Magnetic Hill, Gurudwara Pathar Sahib, and Sangam of Indus and Zanskar rivers.',
        meals: 'Breakfast, Dinner',
        accommodation: 'Hotel in Leh'
      },
      {
        day: 3,
        title: 'Leh to Nubra Valley via Khardung La',
        description: 'Cross Khardung La Pass (18,380 ft), world\'s highest motorable road. Reach Nubra Valley. Visit Diskit Monastery and sand dunes. Camel ride on double-humped camels.',
        meals: 'Breakfast, Dinner',
        accommodation: 'Camp/Hotel in Nubra'
      },
      {
        day: 4,
        title: 'Nubra Valley to Pangong Lake',
        description: 'Drive to Pangong Lake via Shyok route. Experience the changing colors of the lake. Overnight camping near the lake.',
        meals: 'Breakfast, Dinner',
        accommodation: 'Camp at Pangong'
      },
      {
        day: 5,
        title: 'Pangong to Leh',
        description: 'Morning at Pangong Lake. Drive back to Leh via Chang La Pass. Visit Hemis Monastery and Thiksey Monastery en route.',
        meals: 'Breakfast, Dinner',
        accommodation: 'Hotel in Leh'
      },
      {
        day: 6,
        title: 'Leh - Leisure Day',
        description: 'Free day for personal activities or optional excursions to Khardung La, Tso Moriri Lake, or local markets.',
        meals: 'Breakfast, Dinner',
        accommodation: 'Hotel in Leh'
      },
      {
        day: 7,
        title: 'Leh - Alchi and Lamayuru',
        description: 'Day trip to Alchi Monastery and Lamayuru (Moon Land). Visit Likir Monastery. Return to Leh.',
        meals: 'Breakfast, Dinner',
        accommodation: 'Hotel in Leh'
      },
      {
        day: 8,
        title: 'Departure from Leh',
        description: 'Transfer to airport for departure with lifetime memories of Ladakh.',
        meals: 'Breakfast',
        accommodation: 'N/A'
      }
    ]
  }
];

export const internationalTours = [
  {
    id: '7',
    title: 'Dubai Extravaganza',
    destination: 'Dubai - Abu Dhabi',
    duration: '5 Days / 4 Nights',
    price: '₹45,999',
    image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c',
    description: 'Experience luxury and adventure in the UAE with stunning architecture',
    highlights: ['Burj Khalifa', 'Desert Safari', 'Dubai Mall', 'Sheikh Zayed Mosque'],
    category: 'international',
    gallery: [
      'https://images.unsplash.com/photo-1621326445939-ca60c2c15771',
      'https://images.unsplash.com/flagged/photo-1559717865-a99cac1c95d8',
      'https://images.unsplash.com/photo-1569669568857-3badc3643764',
      'https://images.unsplash.com/photo-1590273089302-ebbc53986b6e',
      'https://images.unsplash.com/photo-1584551246679-0daf3d275d0f',
      'https://images.unsplash.com/photo-1512632578888-169bbbc64f33',
      'https://images.unsplash.com/photo-1588310558566-b983c7d257e4',
      'https://images.unsplash.com/photo-1549944850-84e00be4203b',
      'https://images.unsplash.com/photo-1459787915554-b34915863013',
      'https://images.unsplash.com/photo-1518684079-3c830dcef090'
    ],
    inclusions: ['4 nights hotel accommodation', 'Daily breakfast', 'Dubai city tour', 'Desert safari with BBQ dinner', 'Abu Dhabi city tour', 'Burj Khalifa tickets'],
    exclusions: ['International airfare', 'UAE visa', 'Lunch and dinner (except safari)', 'Optional activities'],
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Dubai',
        description: 'Arrive in Dubai and transfer to hotel. Evening visit to Dubai Marina and JBR Beach. Dinner at leisure.',
        meals: 'N/A',
        accommodation: 'Hotel in Dubai'
      },
      {
        day: 2,
        title: 'Dubai City Tour and Burj Khalifa',
        description: 'Visit Dubai Museum, Gold Souk, Spice Souk, and cross Dubai Creek by Abra boat. Afternoon visit to Burj Khalifa 124th floor. Evening at Dubai Mall and fountain show.',
        meals: 'Breakfast',
        accommodation: 'Hotel in Dubai'
      },
      {
        day: 3,
        title: 'Desert Safari',
        description: 'Morning free for shopping or leisure. Afternoon desert safari with dune bashing, camel ride, sandboarding, henna painting, and BBQ dinner with entertainment.',
        meals: 'Breakfast, Dinner',
        accommodation: 'Hotel in Dubai'
      },
      {
        day: 4,
        title: 'Abu Dhabi City Tour',
        description: 'Full day excursion to Abu Dhabi. Visit Sheikh Zayed Grand Mosque, Emirates Palace, Corniche, and Ferrari World (photo stop).',
        meals: 'Breakfast',
        accommodation: 'Hotel in Dubai'
      },
      {
        day: 5,
        title: 'Departure',
        description: 'Free time for last-minute shopping. Transfer to airport for departure.',
        meals: 'Breakfast',
        accommodation: 'N/A'
      }
    ]
  },
  {
    id: '8',
    title: 'Singapore - Malaysia',
    destination: 'Singapore - Kuala Lumpur',
    duration: '6 Days / 5 Nights',
    price: '₹52,999',
    image: 'https://images.unsplash.com/photo-1528543606781-2f6e6857f318',
    description: 'Explore two vibrant countries with modern marvels and cultural heritage',
    highlights: ['Universal Studios', 'Marina Bay', 'Petronas Towers', 'Genting Highlands'],
    category: 'international',
    inclusions: ['5 nights accommodation', 'Daily breakfast', 'Universal Studios tickets', 'City tours', 'Genting Highlands tour', 'Inter-country transfers'],
    exclusions: ['International airfare', 'Visa fees', 'Lunch and dinner', 'Optional activities'],
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Singapore',
        description: 'Arrive in Singapore and transfer to hotel. Evening visit to Marina Bay Sands, Gardens by the Bay, and light show.',
        meals: 'N/A',
        accommodation: 'Hotel in Singapore'
      },
      {
        day: 2,
        title: 'Universal Studios',
        description: 'Full day at Universal Studios Singapore on Sentosa Island. Enjoy thrilling rides and shows.',
        meals: 'Breakfast',
        accommodation: 'Hotel in Singapore'
      },
      {
        day: 3,
        title: 'Singapore City Tour',
        description: 'Visit Merlion Park, Chinatown, Little India, Arab Street, and Orchard Road for shopping.',
        meals: 'Breakfast',
        accommodation: 'Hotel in Singapore'
      },
      {
        day: 4,
        title: 'Singapore to Kuala Lumpur',
        description: 'Morning transfer to Kuala Lumpur by coach. Visit Petronas Twin Towers, KL Tower, and Bukit Bintang for shopping.',
        meals: 'Breakfast',
        accommodation: 'Hotel in Kuala Lumpur'
      },
      {
        day: 5,
        title: 'Genting Highlands Tour',
        description: 'Day trip to Genting Highlands. Enjoy cable car ride, theme park, and casino. Visit Batu Caves on return.',
        meals: 'Breakfast',
        accommodation: 'Hotel in Kuala Lumpur'
      },
      {
        day: 6,
        title: 'Departure',
        description: 'Free time for shopping at Central Market. Transfer to airport for departure.',
        meals: 'Breakfast',
        accommodation: 'N/A'
      }
    ]
  },
  {
    id: '9',
    title: 'Thailand Getaway',
    destination: 'Bangkok - Pattaya - Phuket',
    duration: '7 Days / 6 Nights',
    price: '₹38,999',
    image: 'https://images.unsplash.com/photo-1506953823976-52e1fdc0149a',
    description: 'Discover beautiful beaches, temples, and vibrant nightlife of Thailand',
    highlights: ['Phi Phi Islands', 'Grand Palace', 'Coral Island', 'Safari World'],
    category: 'international',
    inclusions: ['6 nights accommodation', 'Daily breakfast', 'All tours and transfers', 'Phi Phi Island tour', 'Coral Island tour'],
    exclusions: ['International airfare', 'Thailand visa', 'Lunch and dinner', 'Optional activities'],
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Bangkok',
        description: 'Arrive in Bangkok and transfer to Pattaya (2 hours). Check into hotel. Evening visit to Walking Street.',
        meals: 'N/A',
        accommodation: 'Hotel in Pattaya'
      },
      {
        day: 2,
        title: 'Coral Island Tour',
        description: 'Full day tour to Coral Island. Enjoy water sports, snorkeling, and beach activities. Evening Alcazar Show (optional).',
        meals: 'Breakfast',
        accommodation: 'Hotel in Pattaya'
      },
      {
        day: 3,
        title: 'Pattaya to Bangkok',
        description: 'Morning Safari World with Marine Park. Evening transfer to Bangkok. Visit Asiatique Night Market.',
        meals: 'Breakfast',
        accommodation: 'Hotel in Bangkok'
      },
      {
        day: 4,
        title: 'Bangkok City Tour',
        description: 'Visit Grand Palace, Wat Pho (Reclining Buddha), Wat Arun, and take a boat ride on Chao Phraya River.',
        meals: 'Breakfast',
        accommodation: 'Hotel in Bangkok'
      },
      {
        day: 5,
        title: 'Bangkok to Phuket',
        description: 'Fly to Phuket. Transfer to hotel. Evening free to explore Patong Beach and night market.',
        meals: 'Breakfast',
        accommodation: 'Hotel in Phuket'
      },
      {
        day: 6,
        title: 'Phi Phi Island Tour',
        description: 'Full day speedboat tour to Phi Phi Islands. Visit Maya Bay, Pileh Lagoon, Viking Cave, and enjoy snorkeling.',
        meals: 'Breakfast',
        accommodation: 'Hotel in Phuket'
      },
      {
        day: 7,
        title: 'Departure',
        description: 'Morning free for beach activities or shopping. Transfer to airport for departure.',
        meals: 'Breakfast',
        accommodation: 'N/A'
      }
    ]
  },
  {
    id: '10',
    title: 'Europe Dream Tour',
    destination: 'Paris - Switzerland - Italy',
    duration: '10 Days / 9 Nights',
    price: '₹1,25,999',
    image: 'https://images.unsplash.com/photo-1499856871958-5b9627545d1a',
    description: 'Experience the best of Europe with iconic landmarks and scenic beauty',
    highlights: ['Eiffel Tower', 'Swiss Alps', 'Colosseum', 'Venice Canals'],
    category: 'international'
  },
  {
    id: '11',
    title: 'Bali Paradise',
    destination: 'Bali - Ubud - Nusa Dua',
    duration: '6 Days / 5 Nights',
    price: '₹42,999',
    image: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4',
    description: 'Relax in tropical paradise with beautiful beaches and ancient temples',
    highlights: ['Tanah Lot Temple', 'Rice Terraces', 'Water Sports', 'Balinese Spa'],
    category: 'international'
  }
];

export const honeymoonPackages = [
  {
    id: '12',
    title: 'Maldives Romantic Escape',
    destination: 'Male - Resort Islands',
    duration: '5 Days / 4 Nights',
    price: '₹78,999',
    image: 'https://images.unsplash.com/photo-1648538923547-074724ca7a18',
    description: 'Ultimate romantic getaway with overwater villas and pristine beaches',
    highlights: ['Private Beach', 'Candlelight Dinner', 'Water Villa', 'Snorkeling'],
    category: 'honeymoon',
    gallery: [
      'https://images.unsplash.com/photo-1514282401047-d79a71a590e8',
      'https://images.unsplash.com/photo-1573843981267-be1999ff37cd',
      'https://images.unsplash.com/photo-1590523741831-ab7e8b8f9c7f',
      'https://images.unsplash.com/photo-1539367628448-4bc5c9d171c8',
      'https://images.unsplash.com/photo-1589378254089-34f7d94f52b4',
      'https://images.unsplash.com/photo-1580541631950-7282082b53ed',
      'https://images.unsplash.com/photo-1559827260-dc66d52bef19',
      'https://images.unsplash.com/photo-1540202404-2bbc980f95a1',
      'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b',
      'https://images.unsplash.com/photo-1544551763-46a013bb70d5'
    ]
  },
  {
    id: '13',
    title: 'Andaman Honeymoon',
    destination: 'Port Blair - Havelock - Neil Island',
    duration: '6 Days / 5 Nights',
    price: '₹35,999',
    image: 'https://images.pexels.com/photos/1024967/pexels-photo-1024967.jpeg',
    description: 'Romantic beaches, crystal clear waters, and unforgettable sunsets',
    highlights: ['Radhanagar Beach', 'Scuba Diving', 'Glass Bottom Boat', 'Sunset Cruise'],
    category: 'honeymoon'
  },
  {
    id: '14',
    title: 'Kashmir Heaven on Earth',
    destination: 'Srinagar - Gulmarg - Pahalgam',
    duration: '6 Days / 5 Nights',
    price: '₹29,999',
    image: 'https://customer-assets.emergentagent.com/job_explore-skytrips/artifacts/v8yf1whj_Kashmir%20Heaven%20on%20Earth.jpg',
    description: 'Experience paradise with Dal Lake, snow mountains, and Mughal gardens',
    highlights: ['Shikara Ride', 'Mughal Gardens', 'Gondola Ride', 'Apple Orchards'],
    category: 'honeymoon'
  }
];

export const groupTours = [
  {
    id: '15',
    title: 'Group Goa Beach Party',
    destination: 'North & South Goa',
    duration: '4 Days / 3 Nights',
    price: '₹9,999',
    image: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e',
    description: 'Perfect group tour with beaches, nightlife, and adventure activities',
    highlights: ['Beach Activities', 'Water Sports', 'Club Hopping', 'Group Games'],
    category: 'group'
  },
  {
    id: '16',
    title: 'Corporate Outing - Lonavala',
    destination: 'Lonavala - Khandala',
    duration: '2 Days / 1 Night',
    price: '₹6,999',
    image: 'https://customer-assets.emergentagent.com/job_explore-skytrips/artifacts/xwpm5ah1_Corporate%20Outing%20-%20Lonavala.jpg',
    description: 'Team building activities with scenic hill station views',
    highlights: ['Adventure Sports', 'Team Activities', 'Bonfires', 'Hill Trekking'],
    category: 'group'
  }
];

export const pilgrimTours = [
  {
    id: '17',
    title: 'Vaishno Devi Yatra',
    destination: 'Katra - Vaishno Devi',
    duration: '3 Days / 2 Nights',
    price: '₹11,999',
    image: 'https://customer-assets.emergentagent.com/job_explore-skytrips/artifacts/919o7xdu_Vaishno%20Devi%20Yatra.jpg',
    description: 'Sacred pilgrimage to Mata Vaishno Devi with comfortable arrangements',
    highlights: ['Helicopter Service', 'VIP Darshan', 'Accommodation', 'Meals Included'],
    category: 'pilgrim'
  },
  {
    id: '18',
    title: 'Char Dham Yatra',
    destination: 'Yamunotri - Gangotri - Kedarnath - Badrinath',
    duration: '12 Days / 11 Nights',
    price: '₹42,999',
    image: 'https://customer-assets.emergentagent.com/job_explore-skytrips/artifacts/m7tzih93_Char%20Dham%20Yatra.jpg',
    description: 'Complete spiritual journey to four sacred Hindu pilgrimage sites',
    highlights: ['All Four Dhams', 'Comfortable Hotels', 'Experienced Guide', 'All Meals'],
    category: 'pilgrim'
  },
  {
    id: '19',
    title: 'Tirupati Balaji Darshan',
    destination: 'Tirupati',
    duration: '2 Days / 1 Night',
    price: '₹8,999',
    image: 'https://customer-assets.emergentagent.com/job_explore-skytrips/artifacts/9ngybb8j_Tirupati%20Balaji%20Darshan.jpg',
    description: 'Hassle-free darshan at Lord Venkateswara Temple',
    highlights: ['Special Entry Darshan', 'Local Temple Tour', 'Accommodation', 'Prasadam'],
    category: 'pilgrim'
  }
];

export const allTours = [
  ...domesticTours,
  ...internationalTours,
  ...honeymoonPackages,
  ...groupTours,
  ...pilgrimTours
];

export const testimonials = [
  {
    id: 1,
    name: 'Priya & Rahul Sharma',
    location: 'Mumbai',
    rating: 5,
    text: 'Our Maldives honeymoon was absolutely magical! Sky Trips arranged everything perfectly. Highly recommended!',
    tour: 'Maldives Honeymoon'
  },
  {
    id: 2,
    name: 'Amit Patel',
    location: 'Ahmedabad',
    rating: 5,
    text: 'The Golden Triangle tour was well-organized. Our guide was knowledgeable and hotels were excellent.',
    tour: 'Golden Triangle Tour'
  },
  {
    id: 3,
    name: 'Sunita Desai',
    location: 'Pune',
    rating: 5,
    text: 'Kerala backwaters trip was a dream come true. Houseboat experience was unforgettable. Thank you Sky Trips!',
    tour: 'Kerala Backwaters'
  }
];

export const whyChooseUs = [
  {
    icon: 'Award',
    title: 'Experienced Team',
    description: 'Years of expertise in planning perfect holidays across India and abroad'
  },
  {
    icon: 'DollarSign',
    title: 'Best Prices',
    description: 'Competitive pricing with no hidden charges. Get the best value for your money'
  },
  {
    icon: 'Users',
    title: 'Personalized Service',
    description: 'Customized packages tailored to your preferences and budget'
  },
  {
    icon: 'Shield',
    title: 'Safe & Reliable',
    description: 'Your safety is our priority. Trusted by thousands of happy travelers'
  },
  {
    icon: 'Clock',
    title: '24/7 Support',
    description: 'Round-the-clock assistance during your entire journey'
  },
  {
    icon: 'ThumbsUp',
    title: 'Customer Satisfaction',
    description: 'High customer satisfaction rate with hundreds of positive reviews'
  }
];